//
//
//
//
//
//
//
//
//
import request from "./utils/request";
export default {
  name: 'App',
  provide: function provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true //控制视图是否显示的变量

    };
  },
  created: function created() {
    this.getBtn();
  },
  methods: {
    reload: function reload() {
      this.isRouterAlive = false; //先关闭，

      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
    getBtn: function getBtn() {
      var _this = this;

      request({
        url: "admin/AdminSysconfig/getConfig",
        method: 'get',
        params: {
          name: 'showExportBtn'
        }
      }).then(function (res) {
        if (res.code == 200) {
          if (res.data == 0) {
            _this.$store.commit('settings/changeBtn');
          } else {
            _this.$store.commit('settings/restoreBtn');
          }
        }
      });
    }
  }
};